// Constants that outlived the legacy /photoshoot page (REF-5326 / REF-6656 / REF-6599).
// Its providers, history panel and status listener are gone; these values are still
// imported by routed code (Photoshoots list, EditDesignCore, WarningSnackbar, WhatsNew).

export enum PhotoshootType {
  TryOn = "tryon",
  Mannequin = "photoshooting_mannequin",
  Ghost = "ghost_shooting",
}

export const PHOTOSHOOT_TYPES_ARRAY = ["tryon", "photoshooting_mannequin", "ghost_shooting", "tryon_video", "photoshooting_video", "ghost_video"] as const;

export const SHOW_PHOTOSHOOT_NEW_BUTTON = "show_photoshoot_new_button";
export const EventResetPhotoshoot = "RefabricResetPhotoshoot";
export const EventPhotoshootCreationComplete = "photoshoot_creation_complete";
export const EventDispatchFetchPhotoshootHistory = "RefabricDispatchFetchPhotoshootHistory";
